"use client"
import { be } from "@/lib/better-errors"
import * as Sentry from "@sentry/nextjs"
import { useEffect } from "react"

export default function GlobalError({ reset, error }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    if (error) {
      Sentry.captureException(error)
      be.capture(error)
    }
  }, [error])
  return (
    <html lang="en">
      <body>
        <div className="flex h-screen w-screen flex-col items-center justify-center gap-4 p-20">
          <h2 className="text-2xl">Something went wrong!</h2>
          <p>We have been notified</p>
          <button type="submit" onClick={() => reset()} className="hover:underline">
            Try again
          </button>
        </div>
      </body>
    </html>
  )
}
